'use strict';

const _ = require('underscore');
const Backbone = require('backbone');
const Task = require('my/domain/entity/task');
const TaskAPI = require('my/infra/api/task');

class Repository {
    constructor() {
        _.extend(this, Backbone.Events);

        this._tasks = new Backbone.Collection();
    }

    fetch(limit=10, cursor=null) {
        let pagination;
        return TaskAPI.fetch(limit, cursor)
            .then(taskData => {
                const tasksJSON = taskData.results;
                pagination = taskData.pagination;

                return Promise.all(
                    _.map(tasksJSON, j => {
                        return this.build(j);
                    })
                )
            }).then(tasks => {
                tasks = this._tasks.add(tasks, {merge: true});

                return {
                    models: tasks,
                    pagination: pagination
                };
            });
    }

    // key に変更
    add(task, options) {
        const trigger = !this._tasks.get(task.id);
        task = this._tasks.add(task, {merge: true});

        if(trigger) {
            this.trigger('add', task);

            if(options && options.addCount) {
                this.trigger('add:count', task);
            }
        } else {
            this.trigger('update', task);
        }

        return task;
    }

    build(json) {
        return new Task(json);
    }
}

module.exports = new Repository();



// WEBPACK FOOTER //
// ./my/domain/repository/task.js